















import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class CommunityForum extends Vue {
  get appName() {
    return vxm.utility.CandidatePortalApplicationName;
  }
  get forumComingSoonImage() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${
      vxm.jobs.BrandingInfo.companycode
    }/CANDIDATEPORTAL/forum_coming_soon.png`;
  }
  get forumComingSoonMessage() {
    //return vxm.configs.getGlobalConfigValue('HOME_PAGE_FORUM_COMING_SOON_MSG');
    return this.$t('forum-placeholder.coming-soon.message', {
      companyName: this.appName,
    });
  }
  get forumComingSoonHeader() {
    //return (
    //  vxm.configs.getGlobalConfigValue('FORUM_COMING_SOON_HEADER') ||
    //  'Community Forum'
    //);
    return this.$t('forum-placeholder.coming-soon.header', {
      companyName: this.appName,
    });
  }
}
